import { jsx } from "react/jsx-runtime";
import { DecoratorNode } from "lexical";
import { File } from "../../plugins/index.js";
import { $createFileNode, $isFileNode } from "./FileNode.helpers.js";
class FileNode extends DecoratorNode {
    static getType() {
        return 'file';
    }
    static clone(node) {
        return new FileNode(node.id, node.name, node.size, node.__key);
    }
    getId() {
        return this.id;
    }
    createDOM() {
        const dom = document.createElement('span');
        dom.style.display = 'inline-block';
        dom.dataset.fileId = this.id;
        return dom;
    }
    updateDOM(prevNode, dom) {
        if (!$isFileNode(prevNode)) return true;
        const propertiesChanged = this.id !== prevNode.id || this.name !== prevNode.name || this.size !== prevNode.size;
        if (this.id !== prevNode.id) dom.setAttribute('data-file-id', this.id);
        return propertiesChanged;
    }
    decorate(editor) {
        return /*#__PURE__*/ jsx(File, {
            id: this.id,
            name: this.name,
            size: this.size,
            editable: editor._editable
        });
    }
    exportJSON() {
        return {
            type: 'file',
            version: 1,
            id: this.id,
            name: this.name,
            size: this.size
        };
    }
    static importJSON(serializedNode) {
        return $createFileNode(serializedNode.id, serializedNode.name, serializedNode.size);
    }
    constructor(id, name, size, key){
        super(key);
        this.id = id;
        this.name = name;
        this.size = size;
    }
}
export { FileNode };
